// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"8e625001","94":"509f9d6c","145":"509f9d6c","241":"509f9d6c","902":"509f9d6c"}[chunkId] + ".chunk.css";
};